import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { sendTrackingEvent, slugify } from '../../../helpers';

const UnlockButton = ({ feature }) => {
  const intl = useIntl();

  let text = '';
  switch (feature) {
    case 'custom-pages':
      text = intl.formatMessage({ defaultMessage: 'Unlock Content Portals' });
      break;
    case 'duplicate-files':
      text = intl.formatMessage({ defaultMessage: 'Unlock your duplicates' });
      break;
    case 'reports':
      text = intl.formatMessage({ defaultMessage: 'Unlock reports' });
      break;
    case 'upload-pages':
      text = intl.formatMessage({ defaultMessage: 'Unlock guest upload pages' });
      break;
    case 'file-status':
      text = intl.formatMessage({ defaultMessage: 'Unlock file statuses' });
      break;
    case 'custom-categories':
      text = intl.formatMessage({ defaultMessage: 'Unlock Tag Categories' });
      break;
    case 'custom-teams':
      text = intl.formatMessage({ defaultMessage: 'Unlock Teams' });
      break;
    case 'custom-roles':
      text = intl.formatMessage({ defaultMessage: 'Unlock Custom Roles' });
      break;
    case 'file-sizes':
      text = intl.formatMessage({ defaultMessage: 'Unlock file sizes' });
      break;
    case 'download-file-with-metadata':
      text = intl.formatMessage({ defaultMessage: 'Unlock metadata mapping' });
      break;
    case 'image-editor':
      text = intl.formatMessage({ defaultMessage: 'Unlock presets' });
      break;
    case 'share-templates':
      text = intl.formatMessage({ defaultMessage: 'Unlock share templates' });
      break;
    case 'archive':
      text = intl.formatMessage({ defaultMessage: 'Unlock share templates' });
      break;
    case 'ftp':
      text = intl.formatMessage({ defaultMessage: 'Unlock FTP importer' });
      break;
    case 'user-invite-note':
      text = intl.formatMessage({ defaultMessage: 'User invite note' });
      break;
    case 'face-recognition':
      text = intl.formatMessage({ defaultMessage: 'Unlock Facial Recognition' });
      break;
    default:
      break;
  }

  if (!text) {
    return null;
  }

  const trackClick = () => {
    sendTrackingEvent('unlock-button-clicked', { source: feature });
  };

  const elId = `unlock-feature-button-${slugify(feature)}`;

  return (
    <Button
      tag={Link}
      to="/admin/settings/subscription"
      color="primary"
      className="mt-4"
      onClick={trackClick}
      id={elId}
    >
      <i className="far fa-lock mr-2" />
      {text}
    </Button>
  );
};

UnlockButton.propTypes = {
  feature: PropTypes.string.isRequired,
};

export default UnlockButton;
